import React from 'react';
import { Select } from 'antd';
import { OrderedListOutlined } from '@ant-design/icons';
import { ToolbarSortConfig } from './PageToolbar';
import SortIcon from './SortIcon';

const SortGroup: React.FC<{
  sort: ToolbarSortConfig;
}> = ({ sort }) => {
  const hasOptions = Array.isArray(sort.options) && sort.options.length > 0;
  const options = hasOptions
    ? sort.options.map((opt) => ({ value: opt.value, label: opt.label }))
    : [];

  return (
    <div className="pt-sort-group">
      <span className="pt-sort-label">Sort by:</span>
      <div className="pt-sort-pill">
        <div className="pt-sort-icon-prefix">
          <OrderedListOutlined />
        </div>
        <Select
          className="pt-sort-select"
          style={{ width: "auto", minWidth: 240 }}
          value={hasOptions ? sort.field : undefined}
          placeholder="Loading sort options…"
          loading={!hasOptions}
          disabled={!hasOptions}
          onChange={(value) => sort.onChange(value, sort.direction as 'ASC' | 'DESC')}
          options={options}
        />
        <button
          className="pt-sort-btn"
          onClick={() => sort.onChange(sort.field, sort.direction === 'DESC' ? 'ASC' : 'DESC')}
          title="Toggle Sort Order"
          disabled={!hasOptions}
        >
          <SortIcon direction={sort.direction as 'ASC' | 'DESC'} />
        </button>
      </div>
    </div>
  );
};

export default SortGroup;
